import { create } from 'zustand';

const STORAGE_KEY = 'sidebar-collapsed';

function getPersistedState(): boolean {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== null) return stored === 'true';
  } catch {}
  return true; // collapsed by default
}

interface SidebarState {
  isCollapsed: boolean;
  toggle: () => void;
}

export const useSidebarCollapse = create<SidebarState>((set) => ({
  isCollapsed: getPersistedState(),
  toggle: () =>
    set((state) => {
      const next = !state.isCollapsed;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch {}
      return { isCollapsed: next };
    }),
}));
